var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-icon',_vm._b({class:[
    'slds-button__icon',
    ( _obj = {}, _obj[("slds-button__icon_" + _vm.size)] = _vm.size && _vm.size !== 'medium', _obj['slds-button__icon_inverse-hint'] =  _vm.inverse && _vm.hint, _obj['slds-button__icon_hint'] =  _vm.hint && !_vm.inverse, _obj[("slds-button__icon_" + _vm.position)] = _vm.position, _obj ) ],attrs:{"category":_vm.category}},'base-icon',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }